import React from 'react';

const Search: React.SFC<React.SVGProps<SVGSVGElement>> = props => (
    <svg viewBox="0 0 30 30" height="30" width="30" fill="currentColor" {...props}>
        <path
            d="M18.303 17.591l4.197 4.197-.7.712-4.197-4.21c-2.63 2.025-6.08 1.856-8.305-.357a6.09 6.09 0 0 1 0-8.642c2.398-2.386 6.289-2.39 8.683 0 2.228 2.224 2.26 5.946.322 8.3zM9.987 9.988a5.115 5.115 0 1 0 7.237 7.234 5.115 5.115 0 1 0-7.237-7.234z"
            fillRule="nonzero"
        />
    </svg>
);

export default Search;
